import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20modern%20geometric%20composition%20with%20warm%20coral%20and%20cream%20tones%2C%20flowing%20organic%20shapes%2C%20soft%20gradients%2C%20minimalist%20digital%20art%2C%20elegant%20and%20contemporary%20style%2C%20smooth%20textures&width=1800&height=800&seq=hero-bg-2026&orientation=landscape"
        alt="91社区 - 综合性内容平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white mb-4 leading-tight">
            发现精彩，<span className="text-primary-300">连接世界</span>
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
            91社区汇聚海量优质内容，覆盖科技、生活、教育、游戏、影视、健康六大领域，
            为你打开一扇通往精彩世界的大门
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/tech"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-base font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              立即探索
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-white/15 text-white backdrop-blur-sm rounded-full text-base font-medium hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer border border-white/20"
            >
              了解更多
            </Link>
          </div>

          <div className="flex items-center justify-center gap-6 md:gap-10 mt-10">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">12.8万<span className="text-primary-300">+</span></p>
              <p className="text-xs md:text-sm text-white/60 mt-1">优质文章</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">850万<span className="text-primary-300">+</span></p>
              <p className="text-xs md:text-sm text-white/60 mt-1">活跃用户</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">200<span className="text-primary-300">+</span></p>
              <p className="text-xs md:text-sm text-white/60 mt-1">日均更新</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}